import React from 'react';
import { Typography, List, ListItem, ListItemText } from '@material-ui/core';
const Review = ({ checkoutToken }) => (
  <>
    <Typography variant="h6" gutterBottom>Beställning</Typography>
    <List disablePadding>
      {checkoutToken?.live.line_items.map((product) => (
        <ListItem key={product.name}>
          <ListItemText primary={product.name} secondary={`Antal: ${product.quantity}`} />
          <Typography variant="body2">{product.line_total.formatted_with_symbol}</Typography>
        </ListItem>
      ))}
      <ListItem>
        <ListItemText primary="Totalt" />
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
          {checkoutToken.live.subtotal.formatted_with_symbol}
        </Typography>
      </ListItem>
    </List>
  </>
);

export default Review;